import type { ProductSearchModel, ProductSearchReqModelSort } from '@develop/ia-api-library'

// Use as an enum
export const ProductSearchQueryParam = {
  searchTerm: 'search',
  categories: 'kategorie',
  manufacturers: 'hersteller',
  products: 'products',
  offers: 'angebote',
  sorting: 'sorting',
} as const

export type ProductSearchQueryParamValue = (typeof ProductSearchQueryParam)[keyof typeof ProductSearchQueryParam]

export type ProductSearchQueryFilters = {
  searchTerm?: string
  categories?: CategorySlug[]
  manufacturers?: number[]
  products?: string[]
  offers?: boolean
  sorting?: ProductSearchReqModelSort
  page?: number
}

export type ProductSearchResponseWithoutResults = Omit<ProductSearchModel, 'results'>

export type CategorySlug = string
